module.exports = __webpack_public_path__ + "static/media/06.3924aed8.png";